import { AbstractControl, ValidationErrors } from "@angular/forms";

export function scheduledValidator(group: AbstractControl): ValidationErrors | null {
    if (group.get('planning')?.value === 'scheduled') {
        const errors: ValidationErrors = {};
        if (!group.get('planningDate')?.value) errors['planningDateRequired'] = true;
        if (!group.get('planningTime')?.value) errors['planningTimeRequired'] = true;
        return Object.keys(errors).length ? errors : null;
    }
    return null;
}